module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('addressBar', {
    staticClass: "fixed",
    attrs: {
      "isBack": false,
      "goBackLink": '/'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-group "
  }, [(_vm.bannerDatas.length === 0) ? _c('img', {
    staticClass: "banner-slide",
    attrs: {
      "src": require("assets/icon/bannerPlaceHolder.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerDatas.length !== 0) ? _c('mt-swipe', {
    attrs: {
      "auto": 3000
    }
  }, _vm._l((_vm.bannerDatas), function(banner, index) {
    return _c('mt-swipe-item', {
      key: index,
      staticClass: "banner-slide"
    }, [_c('img', {
      attrs: {
        "src": banner.src + '?imageView2/0/w/690/h/740',
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.goBannerEvent(banner)
        }
      }
    })])
  })) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "home-content"
  }, _vm._l((_vm.datas), function(parentCategoryGoodsVo, kIndex) {
    return _c('div', {
      key: kIndex
    }, [_c('div', {
      staticClass: "home-content-cellHeader"
    }, [_c('span', {
      staticClass: "home-content-typeName"
    }, [_vm._v(_vm._s(parentCategoryGoodsVo.name))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "home-content-rightText",
      on: {
        "click": function($event) {
          _vm.goClassify(parentCategoryGoodsVo.id)
        }
      }
    }, [_vm._v("查看全部")]), _vm._v(" "), _c('span', {
      staticClass: "icon-arrow-right home-content-right "
    })])]), _vm._v(" "), _c('hr', {
      staticClass: "home-content-cellHeaderHr",
      staticStyle: {
        "height": "1px",
        "background-color": "#cccccc"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "home-content-cellContent"
    }, _vm._l((parentCategoryGoodsVo.homePageGoodsVos), function(product, pIndex) {
      return _c('span', {
        key: pIndex,
        staticClass: "home-content-cell"
      }, [_c('v-touch', {
        on: {
          "tap": function($event) {
            _vm.goProductEvent(product.goodsChannelId)
          }
        }
      }, [(!!product.imgUrl) ? _c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (product.imgUrl + '?imageView2/0/w/450'),
          expression: "product.imgUrl + '?imageView2/0/w/450'"
        }],
        staticClass: "home-content-cellImg"
      }) : _c('img', {
        staticClass: "home-content-cellImg",
        attrs: {
          "src": require("../../../assets/images/default-pro-small.png")
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "home-content-cellNameText"
      }, [_c('a', {
        staticClass: "home-content-cellNameText",
        staticStyle: {
          "overflow": "hidden",
          "text-overflow": "ellipsis"
        }
      }, [_vm._v(_vm._s(product.displayName))])]), _vm._v(" "), _c('div', {
        staticClass: "home-content-cellPriceText"
      }, [_vm._v("¥" + _vm._s(product.discountPrice / 100))])])], 1)
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "home-footer",
    staticStyle: {
      "height": "60px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dce5693","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home/home.vue
// module id = 558
// module chunks = 1